module.exports = __webpack_public_path__ + "b2ea4b0d6764dbd041d658b84591878c.jpg";